import Device from 'types/models/device';

const archivedSuffix = '-archived';

export const isDeviceArchived = (device: Device) => {
  return device.serialNumber.includes(archivedSuffix);
};